export function isOnlineAuthorization(result) {
  return result && result.discriminator === 'online_authorization';
}
export function isInlineAuthorizationDetails(result) {
  return result ? result.discriminator === 'inline_authorization_details' : false;
}
export function isAuthorizationSuccessful(auth) {
  return auth.result.status === 'authorized' || auth.result.status === 'review';
}
//# sourceMappingURL=checks.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/utilities/checks.js
// module id = 599
// module chunks = 0 1